import planningService from "@/services/planning";
import AbsenceForm from "@/components/ScheduleDetail/AbsenceForm.vue";
import EditForm from "@/components/ScheduleDetail/EditForm.vue";
import AbsencePreview from "@/components/ScheduleDetailPreview/Absence.vue";
import EditPreview from "@/components/ScheduleDetailPreview/Edit.vue";
import conditionHelper from "@/helpers/condition";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
export default {
  computed: {
    ...mapGetters('modificationRequest', {
      modifications: 'modifications'
    }),
    ...mapGetters('mission', {
      currentPkClient: 'currentPkClient',
      pathologies: 'pathologies'
    }),
    modification () {
      return this.modifications.find(
        e => e.idMission === this.intervention.idMission
      )
    },
    permission() {
      return conditionHelper('rcfbusinesssupport');
    }
  },
  watch: {
    modification: {
      handler(val){
        if(!val) return
        this.interventionPreview = val
        this.currentStatus = this.status.isEdited
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.fetchModifyReq()
    if(this.intervention && this.intervention.advMissing ==='true'){
      this.intervention.advMissing = true;
    }
  },
  data() {
    return {
      current: moment().valueOf(),
      googleApiKey: window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
      ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
      items: [
        {
          text: this.$t("planning-view-title"),
          to: { name: "employee-schedule" },
        },
        {
          text:
            this.$route.query.title +
            " " +
            this.formatDate(this.$route.query.start) +
            " " +
            this.formatHour(this.$route.query.start) +
            " " +
            this.formatHour(this.$route.query.end),
          active: true,
        },
      ],
      intervention: { ...this.$route.query },
      interventionPreview: {},
      isShowButton: true,
      currentStatus: null,
      status: {
        isEdit: 1,
        isAbsence: 2,
        isEdited: 3,
        isAbsent: 4
      },
      hidden: nodeEnv !== 'development',
    };
  },
  components: {
    AbsenceForm,
    EditForm,
    AbsencePreview,
    EditPreview
  },
  methods: {
    ...mapActions("modificationRequest", {
      fetchModifyReq: "REFRESH"
    }),
    ...mapActions('mission', ['getPathologies']),
    formatDate(data) {
      const date = this.$options.filters.formatUnixFullDate(data);
      return this.$options.filters.capitalize(date)
    },
    formatHour(data) {
      return this.$options.filters.formatUnixHeure(data);
    },
    getStaticMapURL(mission) {
      return `https://maps.google.com/maps/api/staticmap?
        center=${mission.lat},${mission.lng}
        &size=365x256&scale=1&sensor=false&zoom=16
        &markers=${mission.lat}%2C${mission.lng}
        &key=${this.googleApiKey}`;
    },
    edit() {
      this.currentStatus = this.status.isEdit;
    },
    absence() {
      this.currentStatus = this.status.isAbsence;
    },
    createRequest(id) {
      planningService.createRequest(id, this.intervention).then((res) => {});
    },
    cancel(id){
      planningService.deleteModificationRequest(id).then((res) => {
        this.interventionPreview = {}
        this.currentStatus = null;
      });
    },
    afterSave(interventionPreview){
      this.currentStatus = this.status.isEdited
      this.interventionPreview = interventionPreview;
    },
    async onClick(pkClient) {
      if (String(this.currentPkClient) !== String(pkClient)) {
        await this.getPathologies(pkClient);
      }
      this.$router.push({ name: "employee-support-business", query: { pathologies: this.pathologies } });
    }
  },
};
